<vivest-card variant="default" full-width data-testid="plano-institutos">
  <form class="plano-institutos" novalidate [formGroup]="form" (submit)="$event.preventDefault(); salvar()">
    <header class="plano-institutos__topo">
      <div class="plano-institutos__titulo-grupo">
        <h2 class="plano-institutos__titulo">Institutos</h2>
        <p class="plano-institutos__descricao">Configure os institutos disponíveis para este plano e defina sua vigência.</p>
      </div>
      <div class="plano-institutos__acoes-topo">
        <!-- Elegibilidade do extrato de desligamento: quais institutos o participante vê ao se desligar. -->
        <vivest-button variant="outline" size="md" data-testid="plano-institutos-extrato" (click)="abrirExtratoDesligamento()">
          <vivest-icon slot="icon-left" name="file-text" source="feather"></vivest-icon>
          Extrato de desligamento
        </vivest-button>
        <vivest-button variant="primary" size="md" data-testid="plano-institutos-associar" (click)="associar()">
          <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
          Associar Instituto
        </vivest-button>
      </div>
    </header>

    <p class="plano-institutos__aviso" role="note" data-testid="plano-institutos-aviso">
      <vivest-icon name="info" source="feather" aria-hidden="true"></vivest-icon>
      Os institutos ativados serão exibidos aos participantes conforme as regras de elegibilidade configuradas.
    </p>

    <!-- Durante o carregamento o loader global cobre a tela; nada é exibido aqui. -->
    @if (!carregando() && !linhas().length) {
      <!-- Plano recém-criado: os institutos entram ao serem associados e configurados. -->
      <app-empty-state
        data-testid="plano-institutos-vazio"
        message="Nenhum instituto associado a este plano. Use &quot;Associar Instituto&quot; para escolher e configurar um instituto."
      />
    } @else if (!carregando()) {
      <div class="plano-institutos__tabela-scroll">
        <table class="plano-institutos__tabela" formArrayName="institutos" data-testid="plano-institutos-tabela">
          <colgroup>
            <col class="plano-institutos__col-instituto" />
            <col class="plano-institutos__col-status" />
            <col class="plano-institutos__col-data" />
            <col class="plano-institutos__col-data" />
            <col class="plano-institutos__col-disponivel" />
            <col class="plano-institutos__col-acoes" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col" rowspan="2">Instituto</th>
              <th scope="col" rowspan="2" class="plano-institutos__centro">Status</th>
              <th scope="colgroup" colspan="2" class="plano-institutos__grupo">Vigência</th>
              <th scope="col" rowspan="2" class="plano-institutos__centro">Disponível para Participante</th>
              <th scope="col" rowspan="2" class="plano-institutos__direita">Ações</th>
            </tr>
            <tr>
              <th scope="col" class="plano-institutos__subcabecalho">Início</th>
              <th scope="col" class="plano-institutos__subcabecalho">Fim</th>
            </tr>
          </thead>
          <tbody>
            @for (linha of linhas(); track linha.id; let i = $index) {
              <tr
                [formGroupName]="i"
                [class.plano-institutos__linha--inativa]="status(linha) === 'Inativo'"
                [attr.data-testid]="'plano-institutos-linha-' + linha.tipo"
              >
                <th scope="row" class="plano-institutos__nome">{{ linha.nome }}</th>
                <td class="plano-institutos__centro">
                  <vivest-tag type="status" [variant]="status(linha) === 'Ativo' ? 'success' : 'warning'">
                    {{ status(linha) }}
                  </vivest-tag>
                </td>
                <!-- Vigência da configuração do instituto: só leitura aqui, editada em "Configurar". -->
                <td class="plano-institutos__data" data-testid="plano-institutos-inicio">
                  {{ data(linha.vigenciaInicio, 'Não informado') }}
                </td>
                <td class="plano-institutos__data" data-testid="plano-institutos-fim">
                  {{ data(linha.vigenciaFim, 'Sem término') }}
                </td>
                <td class="plano-institutos__centro">
                  <vivest-switch
                    formControlName="disponivel"
                    [attr.aria-label]="linha.nome + ' disponível para participante'"
                    [attr.title]="status(linha) === 'Inativo' ? 'Ative o instituto para disponibilizá-lo' : null"
                    data-testid="plano-institutos-disponivel"
                  ></vivest-switch>
                </td>
                <td class="plano-institutos__direita">
                  <app-menu-acoes
                    [rotulo]="'Ações de ' + linha.nome"
                    [opcoes]="opcoesDe(linha)"
                    (escolher)="escolherAcao(linha, $event)"
                    data-testid="plano-institutos-acoes"
                  />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <p class="plano-institutos__nota" data-testid="plano-institutos-nota-vigencia">
        A vigência de cada instituto é definida na configuração dele, pelo "Configurar" do menu de ações.
      </p>
    }

    <!-- Prazo de opção pelos institutos: configuração de cada plano. -->
    <section class="plano-institutos__secao" aria-labelledby="plano-institutos-prazo-titulo" data-testid="plano-institutos-prazo">
      <div class="plano-institutos__titulo-grupo">
        <h3 id="plano-institutos-prazo-titulo" class="plano-institutos__subtitulo">Prazo de Opção pelos Institutos</h3>
        <p class="plano-institutos__descricao">
          Defina até quando o participante pode optar por um instituto depois de receber o extrato de desligamento.
        </p>
      </div>
      <div class="plano-institutos__opcao plano-institutos__prazo">
        <vivest-input
          class="plano-institutos__prazo-campo"
          autocomplete="off"
          icon=""
          label="Prazo"
          name="prazo-opcao"
          placeholder="Dias"
          type="text"
          required
          formControlName="prazoDias"
          aria-describedby="plano-institutos-prazo-regra"
          [attr.status]="erroPrazo() ? 'error' : 'default'"
          [attr.error-message]="erroPrazo()"
          data-testid="plano-institutos-prazo-dias"
        ></vivest-input>
        <p id="plano-institutos-prazo-regra" class="plano-institutos__prazo-regra" data-testid="plano-institutos-prazo-regra">
          dias após o recebimento do extrato de desligamento
        </p>
      </div>
    </section>

    <section class="plano-institutos__secao" aria-labelledby="plano-institutos-combinacao-titulo">
      <div class="plano-institutos__titulo-grupo">
        <h3 id="plano-institutos-combinacao-titulo" class="plano-institutos__subtitulo">Combinação de Institutos</h3>
        <p class="plano-institutos__descricao">
          Defina se é permitida a solicitação de mais de um instituto pelo participante, considerando as regras de negócio do plano.
        </p>
      </div>
      <div class="plano-institutos__opcao">
        <vivest-checkbox
          label-variant="multi-line"
          name="permitir-combinacao"
          formControlName="permitirCombinacao"
          aria-describedby="plano-institutos-combinacao-dica"
          data-testid="plano-institutos-combinacao"
        >
          Permitir combinação de institutos
        </vivest-checkbox>
        <p id="plano-institutos-combinacao-dica" class="plano-institutos__dica">
          Quando habilitado, o participante poderá solicitar mais de um instituto, desde que atenda às regras de elegibilidade.
        </p>
      </div>
    </section>

    <footer class="plano-institutos__rodape">
      <!-- Desfaz o que ainda não foi salvo e continua na aba; só habilita com alterações pendentes. -->
      <vivest-button
        variant="outline"
        size="md"
        [disabled]="!temAlteracoes()"
        data-testid="plano-institutos-descartar"
        (click)="descartar()"
      >
        Descartar alterações
      </vivest-button>
      <vivest-button
        variant="primary"
        size="md"
        [disabled]="!podeSalvar()"
        data-testid="plano-institutos-salvar"
        (click)="salvar()"
      >
        {{ salvando() ? 'Salvando…' : 'Salvar' }}
      </vivest-button>
    </footer>
  </form>
</vivest-card>

<!-- Confirmação antes de salvar (vivest-modal do design system). -->
<vivest-modal
  heading="Salvar institutos"
  description="Confirma as alterações nos institutos deste plano?"
  [open]="confirmandoSalvar()"
  [hasIcon]="false"
  dismissible=""
  (vivest-close)="cancelarSalvar()"
  data-testid="plano-institutos-confirmar"
>
  <vivest-button
    slot="actions"
    variant="outline"
    size="md"
    data-testid="plano-institutos-confirmar-voltar"
    (click)="cancelarSalvar()"
  >
    Voltar
  </vivest-button>
  <vivest-button
    slot="actions"
    variant="primary"
    size="md"
    data-testid="plano-institutos-confirmar-salvar"
    (click)="confirmarSalvar()"
  >
    Salvar
  </vivest-button>
</vivest-modal>
